import { useCallback, useState } from 'react'
import { subscribeNewsletter } from '@/modules/marketing/services/newsletter.service'

/**
 * Newsletter signup for marketing sections. {@code pageSource} is sent to the API (sanitized server-side).
 */
export function useNewsletterSubscribe(pageSource: string) {
  const [email, setEmail] = useState('')
  const [busy, setBusy] = useState(false)
  const [info, setInfo] = useState<string | null>(null)
  const [err, setErr] = useState<string | null>(null)

  const onSubmit = useCallback(
    async (e: React.FormEvent) => {
      e.preventDefault()
      setInfo(null)
      setErr(null)
      setBusy(true)
      try {
        const r = await subscribeNewsletter({ email, source: pageSource })
        setInfo(r.message)
        setEmail('')
      } catch (e: unknown) {
        const msg =
          e && typeof e === 'object' && 'message' in e
            ? String((e as { message: string }).message)
            : 'Could not subscribe. Please try again later.'
        setErr(msg)
      } finally {
        setBusy(false)
      }
    },
    [email, pageSource]
  )

  return { email, setEmail, onSubmit, busy, info, err }
}
